export const pluralize = (word, count) => {
  if (count > 1 && !word.endsWith('s')) {
    return word + 's'
  } else if (count === 1 && word.endsWith('s')) {
    return word.slice(0, -1)
  } else {
    return word
  }
}
